import { httpsCallable } from "firebase/functions";
import { functions } from "../config/firebase";

const chatSupportCall = httpsCallable(functions, "chatSupport");
export const askRomiAssistant = async (message, history = []) => (await chatSupportCall({ message, history })).data;
